import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  FormControl,
} from "@mui/material";
import SeasonRegistrationService from "services/SeasonRegistrationService";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 270,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const CropYearModal = ({ isOpen, onClose, onConfirm }) => {
  const [cropYearList, setCropYearList] = useState([]);
  const [selectedCropYear, setSelectedCropYear] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCropYears();
  }, []);

  const fetchCropYears = async () => {
    setLoading(true);
    try {
      const response = await SeasonRegistrationService.getCropYears();
      const cropYears = (response?.data?.response || []).map((item) => ({
        uid: item.cropYearUid,
        name: item.cropYearName,
      }));
      setCropYearList(cropYears);
       if (cropYears.length > 0) {
      setSelectedCropYear(cropYears[0].name);
    }
    } catch (error) {
      console.error("Failed to fetch crop years:", error);
      setCropYearList([]);
    }
    setLoading(false);
  };

  const handleConfirmYear = () => {
  if (onConfirm) {
  onConfirm(selectedCropYear);
}
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box sx={style}>
        <Typography align="center" sx={{color:'#737D86',fontFamily:'Montserrat',
            fontWeight:500,}}>
          Select Crop Year
        </Typography>

        <FormControl
          sx={{
            mt:2,
            width: 220,
            height: 40,
            display: "flex",
            alignItems: "center",
            mx: "auto", // this centers the box horizontally
          }}
        >
          <Select
            value={selectedCropYear}
            onChange={(e) => setSelectedCropYear(e.target.value)}
            displayEmpty
            sx={{
              width: "100%",
              height: 40,
            }}
          >
            {/* <MenuItem value="">
              <em style={{ color: "#CDCCCC", fontWeight: 400 }}>Select Year</em>
            </MenuItem> */}
            {cropYearList.map((year) => (
              <MenuItem key={year.uid} value={year.name}  sx={{ fontWeight: 400 }}>
                CY {year.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            sx={{
              borderRadius: 10,
              minWidth: 90,
              minHeight: 42,
              background: "#737D86",
              fontFamily:'Montserrat',
             mt:3,
              "&:hover": {
                backgroundColor: "#737D86",
              },
            }}
            variant="contained"
            onClick={onClose}
          >
            BACK
          </Button>
          <Button
            sx={{
              borderRadius: 4,
              minWidth: 90,
              minHeight: 42,
              background: "#EF7D00",
              fontFamily:'Montserrat',
              mt:3,
              "&:hover": {
                backgroundColor: "#EF7D00",
              },
            }}
            variant="contained"
            onClick={handleConfirmYear}
          >
            OK
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CropYearModal;
